var ComponentTypes;
(function (ComponentTypes) {
    ComponentTypes["ALL"] = "";
    ComponentTypes["RULE"] = "type:rule";
    ComponentTypes["ACTION"] = "type:email";
    ComponentTypes["INTEGRATION"] = "type:integration";
    ComponentTypes["BUSINESS_EVENT"] = "type:business-event";
})(ComponentTypes || (ComponentTypes = {}));
export default ComponentTypes;
